import { defineAsyncComponent, type Component } from 'vue'

// Icons are lazy-loaded on first render and cached for the rest of the session.
const svgIconMap: Record<string, Component> = {
  sparkle: defineAsyncComponent(() => import('./svg/SparkleIcon.vue')),
  'checkbox-check': defineAsyncComponent(() => import('./svg/CheckedIcon.vue')),
  'checkbox-indeterminate': defineAsyncComponent(() => import('./svg/MinusIcon.vue')),
  minus: defineAsyncComponent(() => import('./svg/MinusIcon.vue')),
  info: defineAsyncComponent(() => import('./svg/InfoIcon.vue')),
  close: defineAsyncComponent(() => import('./svg/CloseIcon.vue'))
}

export default svgIconMap
